import { scrollToSection } from './scrollToSection';

export function scrollToVideoSection() {
  scrollToSection('see-creaticode-in-action', 'hero-section');
}
